var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4697 3.46967C11.7626 3.17678 12.2374 3.17678 12.5303 3.46967L16.0303 6.96967C16.3232 7.26256 16.3232 7.73744 16.0303 8.03033C15.7374 8.32322 15.2626 8.32322 14.9697 8.03033L12.75 5.81066V16C12.75 16.4142 12.4142 16.75 12 16.75C11.5858 16.75 11.25 16.4142 11.25 16V5.81066L9.03033 8.03033C8.73744 8.32322 8.26256 8.32322 7.96967 8.03033C7.67678 7.73744 7.67678 7.26256 7.96967 6.96967L11.4697 3.46967ZM5.25 20C5.25 19.5858 5.58579 19.25 6 19.25H18C18.4142 19.25 18.75 19.5858 18.75 20C18.75 20.4142 18.4142 20.75 18 20.75H6C5.58579 20.75 5.25 20.4142 5.25 20Z",
    fill: "#7B7D7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.1880574cbea77ba1a54ca206a159df2d.svg";
export { ForwardRef as ReactComponent };